export class MapAnalystDetailModel {
    constructor() {
        this.userId = "";
        this.userName = "";
        this.states = [];
    }
}
export default class MapAnalystDetail extends MapAnalystDetailModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
